import React from 'react'
import { Aprobed } from '../../../../lib/svg'
const Step4 = props => {
  return (
    <div className="ahorroYa-register__form__screen-has-register">
      <Aprobed className="ahorroYa-register__form__screen-icon-2" />
      <>
        <div className="ahorroYa-register__form__screen-title-2">
          Ya eres parte de AhorroYa!
        </div>
        <div className="ahorroYa-register__form__screen-paragraph">
          En unos minutos recibirás un correo de bienvenidacon todo lo que
          tenemos para ti. <br />
          <br />
          <strong>
            ¡Empieza a disfrutar de los beneficios en todos nuestros
            establecimientos aliados!
          </strong>
        </div>
      </>
    </div>
  )
}

export default Step4
